<template>
  <header class="sub-header">
    <div class="sub-header__bg"></div>
    <div class="sub-header__overlay"></div>
    <router-link to="/" class="sub-header__link sub-header__icon-wrapper">
      <img
        class="sub-header__icon"
        src="@/assets/svg/back_small.svg"
        alt="Takaisin"
      />
    </router-link>
    <div class="sub-header__wrapper">
      <h1 class="sub-header__heading">{{ title }}</h1>
    </div>
  </header>
</template>

<script>
export default {
  props: ['title'],
};
</script>

<style lang="scss">
.sub-header {
  position: sticky;
  top: 0;
  z-index: 10;
  // Prevents text from shining through the header
  background-color: white;
  height: 50px;
  height: calc(50px + env(safe-area-inset-top));
  color: $almost-black;
  color: white;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: env(safe-area-inset-top);
  overflow: hidden;

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #bbcedd url('~@/assets/img/laturi_bg.jpg');
    background-size: cover;
    background-position: center -30px;
    background-repeat: no-repeat;
    filter: blur(2px);
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(#000, 0.25);
    z-index: 0;
  }

  &__wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    z-index: 1;
  }

  &__heading {
    @include font-black();
    font-size: 20px;
    line-height: 1;
    margin: 0;
    text-align: center;
    width: 100%;
  }

  &__icon-wrapper {
    position: absolute;
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    bottom: 0;
  }

  &__icon {
    height: 22px;
    line-height: 1;
    margin-left: 15px;
  }

  &__link {
    line-height: 1;
    z-index: 100;
    // background: rgba(255, 255, 255, 0.3);
  }
}
</style>
